<template>
  <div>
    <c3-chart :height="350" :data="chartData" :config="chartConfig" type='line' />
    <div class="text-center text-muted">
      <template slot-scope="scope">
        {{ $t('reports_ui.fleet_health_report.open_vehicle_issues_over_time')}}
      </template>
    </div>
  </div>
</template>

<script>
import C3Chart from '@/components/shared/chart/C3Chart.vue'
import { filter, map, isEmpty, get, round } from 'lodash'

export default {
  name: 'DailyOpenedAndClosedViolations',
  components: {
    C3Chart
  },
  props: {
    customerReport: {
      type: Object
    }
  },
  computed: {
    /**
     * Get entries for all dates with data, filtering out those that don't.
     */
    filteredEntries () {
      return filter(this.customerReport.route_assessment_metrics, x => !isEmpty(x))
    },
    /**
     * Format the chart data needed for the graph.
     * @returns Object
     */
    chartData () {
      const dateColumn = this.getMappedData('date')
      dateColumn.unshift('date')

      const openedColumn = this.getMappedData('opened')
      openedColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.opened_violations'))

      const closedColumn = this.getMappedData('closed')
      closedColumn.unshift(this.$t('reports_ui.route_assessment_metrics_report.closed_violations'))

      return {
        x: 'date',
        columns: [
          dateColumn,
          openedColumn,
          closedColumn
        ]
      }
    },
    /**
     * The chart config.
     */
    chartConfig () {
      return {
        axis: {
          x: {
            label: {
              text: 'Date'
            },
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d',
              centered: true
            }
          },
          y: {
            label: {
              text: this.$t('number_of_violations')
            },
            tick: {
              format: function (d) {
                return round(d, 1)
              },
              culling: true
            }
          }
        },
        line: {
          connectNull: true
        }
      }
    }
  },
  methods: {
    /**
     * Convenience method to get data from the insights_dashboard_history field.
     * @param field
     * @returns {*}
     */
    getMappedData (field) {
      return map(this.customerReport.route_assessment_metrics, x => get(x, field, null))
    }
  }
}
</script>

<style scoped>

</style>
